import { render, staticRenderFns } from "./DynamicsChart.vue?vue&type=template&id=482fbf0d&scoped=true&"
import script from "./DynamicsChart.vue?vue&type=script&lang=js&"
export * from "./DynamicsChart.vue?vue&type=script&lang=js&"
import style0 from "./DynamicsChart.vue?vue&type=style&index=0&id=482fbf0d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fbf0d",
  null
  
)

export default component.exports